import { CustomerForm } from '../constants/formTypes'
import { FormWrapper } from './formWrapper'
import { DepositInformationForm } from 'original/formBuilder/forms/depositInformationForm'
import { PepInformationFormDE_NO } from './forms/pepInformationFormDE_NO'
import { PepInformationForm } from 'original/formBuilder/forms/pepInformationForm'
import { PepInformationBalticForm } from 'original/formBuilder/forms/pepInformationBalticForm'
import { LoanInformationForm } from 'original/formBuilder/forms/loanInformationForm'
import { SetPasswordIdCheckForm } from './forms/setPasswordIdCheckForm'
import { ContactForm } from './forms/contactForm'
import appConfig from 'app.config'
import { LoanInformationFormFi } from 'original/formBuilder/forms/loanInformationFormFi'
import { LoanInformationFormEe } from 'original/formBuilder/forms/loanInformationFormEe'
import { LoanInformationFormLv } from 'original/formBuilder/forms/loanInformationFormLv'
import { LoanInformationFormLt } from 'original/formBuilder/forms/loanInformationFormLt'
import { DepositInformationFormFi } from 'original/formBuilder/forms/depositInformationFormFi'
import { DepositInformationFormNo } from './forms/depositInformationFormNo'
import { CustomerInformationFormSddDE_AT } from './forms/customerInformationFormSddDE_AT'
import { CashToAccountForm } from './forms/cashToAccountFormDe'
import { OtpStartFormEs } from 'auth/formBuilder/forms/otpStartFormEs'
import { OtpCompleteForm } from 'auth/formBuilder/forms/otpCompleteForm'
import { DepositInformationFormDe } from './forms/depositInformationFormDe'

export function FormFactory(formType: CustomerForm, formMeta: any, data?: any) {
	const country = appConfig.country
	switch (formType) {
		case CustomerForm.DepositForm:
			if (country === 'se')
				return composeForm(
					[DepositInformationForm(data), PepInformationForm(data)],
					formMeta,
				)
			if (country === 'fi')
				return composeForm(
					[DepositInformationFormFi(data), PepInformationForm(data)],
					formMeta,
				)
			if (country === 'no')
				return composeForm(
					[
						DepositInformationFormNo(data),
						PepInformationFormDE_NO(data),
					],
					formMeta,
				)
			if (country === 'de')
				return composeForm(
					[
						DepositInformationFormDe(data),
						PepInformationFormDE_NO(data),
					],
					formMeta,
				)
			break
		case CustomerForm.LoanForm:
			if (country === 'se')
				return composeForm(
					[LoanInformationForm(data), PepInformationForm(data)],
					formMeta,
				)
			if (country === 'fi')
				return composeForm(
					[LoanInformationFormFi(data), PepInformationForm(data)],
					formMeta,
				)
			if (country === 'ee')
				return composeForm(
					[
						LoanInformationFormEe(data),
						PepInformationBalticForm(data),
					],
					formMeta,
				)
			if (country === 'lv')
				return composeForm(
					[
						LoanInformationFormLv(data),
						PepInformationBalticForm(data),
					],
					formMeta,
				)
			if (country === 'lt')
				return composeForm(
					[
						LoanInformationFormLt(data),
						PepInformationBalticForm(data),
					],
					formMeta,
				)
			break
		case CustomerForm.CustomerInformationFormSDD:
			return FormWrapper(
				[CustomerInformationFormSddDE_AT(data)],
				formMeta,
			)
		case CustomerForm.SetPasswordIdCheckForm:
			return FormWrapper([SetPasswordIdCheckForm(data)], formMeta)
		case CustomerForm.ContactForm:
			return FormWrapper([ContactForm()], formMeta)
		case CustomerForm.CashToAccountForm:
			return FormWrapper([CashToAccountForm()], formMeta)
		case CustomerForm.OtpStartFormEs:
			return FormWrapper([OtpStartFormEs(data)], formMeta)
		case CustomerForm.OtpCompleteForm:
			return FormWrapper([OtpCompleteForm(data)], formMeta)
		default:
			return Object.assign({})
	}
}

const composeForm = (formPartials: any, formMeta: any) => {
	return FormWrapper(formPartials, formMeta)
}
